<template>
	<div class="left-side" v-if="facebook || twitter || linkedin || instagram">
		<div class="page-header">
			<h1 class="m-n text-u-c title-font">Social media</h1>
		</div>
		<div class="row">
			<a :href="facebook" target="_blank" class="col-lg-12 m-b-md p-x-n" v-if="facebook">
				<img class="social-img" src="/vue-app/assets/img/facebook.svg">
				<span class="text-ellipsis text-font">{{ facebook | formatUrl}}</span>
			</a>
			<a :href="twitter" target="_blank" class="col-lg-12 m-b-md p-x-n" v-if="twitter">
        <img class="social-img" src="/vue-app/assets/img/twitter.svg">
				<span class="text-ellipsis text-font">{{ twitter | formatUrl }}</span>
			</a>
			<a :href="instagram" target="_blank" class="col-lg-12 m-b-md p-x-n" v-if="instagram">
        <img class="social-img" src="/vue-app/assets/img/instagram.svg">
				<span class="text-ellipsis text-font">{{ instagram | formatUrl }}</span>
			</a>
			<a :href="linkedin" target="_blank" class="col-lg-12 m-b-md p-x-n" v-if="linkedin">
        <img class="social-img" src="/vue-app/assets/img/linkedIn.svg">
				<span class="text-ellipsis text-font">{{ linkedin | formatUrl }}</span>
			</a>
		</div>
	</div>
</template>

<script>

	export default {
    filters: {
      formatUrl: function (value) {
        if (!value) return '';
        value = value.toString();
        return value.replace(/(^\w+:|^)\/\//, '');
      }
    },
    computed:{
      profile(){
        return this.$store.getters.profile;
      },
      facebook(){
        const r = this.profile.corporateProfile.social_accounts.find(account => account.service === 'facebook');
        return r ? r.link : null;
      },
      twitter(){
        const r = this.profile.corporateProfile.social_accounts.find(account => account.service === 'twitter');
        return r ? r.link : null;
      },
      linkedin(){
        const r = this.profile.corporateProfile.social_accounts.find(account => account.service === 'linkedin');
        return r ? r.link : null;
      },
      instagram(){
        const r = this.profile.corporateProfile.social_accounts.find(account => account.service === 'instagram');
        return r ? r.link : null;
      }
	  }
  }
</script>
<style lang="scss" scoped>
.social-img {
  margin-bottom: 5px;
}
@media only screen and (min-width: 1200px) {
	.left-side .page-header {
		padding-bottom: 20px;
	}
	.title-font {
		font-weight: 300;
		font-size: 20px;
		line-height: 20px;
		color: #000;
	}
	.text-font {
		font-weight: 300;
		font-size: 13px;
		line-height: 15px;
		color: #000;
	}	
	.page-header {
		margin: 0px;
	}
	.row {
		margin: 0px;
	}
}
@media only screen and (max-width: 1199px) and (min-width: 768px) {
	.left-side .page-header {
		padding-bottom: 20px;
	}
	.title-font {
		font-weight: 300;
		font-size: 18px;
		line-height: 18px;
		color: #000;
	}
	.text-font {
		font-weight: 300;
		font-size: 11px;
		line-height: 15px;
		color: #000;
	}	
	.page-header {
		margin: 0px;
	}
	.row {
		margin: 0px;
	}
}
@media only screen and (max-width: 767px) {
	.left-side {
		padding-left: 20px;
	}
	.left-side .page-header {
		padding-bottom: 20px;
	}
	.title-font {
		font-weight: 300;
		font-size: 20px;
		line-height: 20px;
		color: #000;
	}
	.text-font {
		font-weight: 300;
		font-size: 13px;
		line-height: 15px;
		color: #000;
	}	
	.page-header {
		margin: 0px;
	}
	.row {
		margin: 0px;
	}
}

</style>

